let url = "";
let url_admin = "";
let wsHost = "";
let wsPort = "";
let wsKey = "";
let mapsApiKey;

if (process.env.NODE_ENV === "development") {
	url = "http://localhost:8000";
	url_admin = "http://localhost:3000";
	wsHost = "localhost";
	wsPort = '6001';
	wsKey = "d634e6cc6f7f05b42cab";
	mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCR_ANXyci3y67vqYyxSbosjjJXxDF8x4w";
} else {
	url = "https://api.choff.com.br";
	url_admin = "https://admin.choff.com.br";
	wsHost = "ws.choff.com.br";
	wsPort = '6001';
	wsKey = "d634e6cc6f7f05b42cab";
	mapsApiKey = "AIzaSyCR_ANXyci3y67vqYyxSbosjjJXxDF8x4w";
}

export const Constants = {
	url: url,
	baseUrl: url + "/api/web",
	url_admin,
	wsHost: wsHost,
	wsPort: wsPort,
	wsKey: wsKey,
	mapsApiKey: mapsApiKey
};

export const listControllers = {
	"App\\Http\\Controllers\\Admin\\AuthController": "AutenticaÃ§Ã£o",
	"App\\Http\\Controllers\\Admin\\GroupController": "Grupo de permissÃ£o",
};

export const listFunctions = {
	auth: "Entrar",
	forgotPassword: "Recuperar senha",
	resetPassword: "Trocar senha",
	store: "Cadastrar",
	update: "Atualizar",
	get: "Visualizar",
	delete: "Apagar",
	list: "Listar",
	destroy: "Apagar",
	simpleList: "Lista simples",
};

export const textoExclusao = {
	title: "AtenÃ§Ã£o!",
	text: "Tem certeza que deseja remover esse item?",
	icon: "warning",
	showCancelButton: true,
	confirmButtonColor: "#3085d6",
	cancelButtonColor: "#d33",
	cancelButtonText: "NÃ£o",
	confirmButtonText: "Sim",
};

export const listaStatus = [
	{
		label: 'Ativo',
		value: 1
	},
	{
		label: 'Inativo',
		value: 0
	}
];

export const listaUfs = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"];

export const listaEstados = [
	{ key: "AC", label: "Acre" },
	{ key: "AL", label: "Alagoas" },
	{ key: "AP", label: "AmapÃ¡" },
	{ key: "AM", label: "Amazonas" },
	{ key: "BA", label: "Bahia" },
	{ key: "CE", label: "CearÃ¡" },
	{ key: "DF", label: "Distrito Federal" },
	{ key: "ES", label: "EspÃ­rito Santo" },
	{ key: "GO", label: "GoiÃ¡s" },
	{ key: "MA", label: "MaranhÃ£o" },
	{ key: "MT", label: "Mato Grosso" },
	{ key: "MS", label: "Mato Grosso do Sul" },
	{ key: "MG", label: "Minas Gerais" },
	{ key: "PA", label: "ParÃ¡" },
	{ key: "PB", label: "ParaÃ­ba" },
	{ key: "PR", label: "ParanÃ¡" },
	{ key: "PE", label: "Pernambuco" },
	{ key: "PI", label: "PiauÃ­" },
	{ key: "RJ", label: "Rio de Janeiro" },
	{ key: "RN", label: "Rio Grande do Norte" },
	{ key: "RS", label: "Rio Grande do Sul" },
	{ key: "RO", label: "RondÃ´nia" },
	{ key: "RR", label: "Roraima" },
	{ key: "SC", label: "Santa Catarina" },
	{ key: "SP", label: "SÃ£o Paulo" },
	{ key: "SE", label: "Sergipe" },
	{ key: "TO", label: "Tocantins" },
];

export const listaSimNao = [
	{ value: 1, label: "Sim" },
	{ value: 0, label: "NÃ£o" },
];

export const listaFormatoImagens = ["jpg", "png", "jpeg", "image/jpg", "image/png", "image/jpeg"];
export const listaFormatoVideos = ["mp4", "avi", "video/mp4", "video/avi"];

export const listaTipoPessoa = [
	{ key: "PF", label: "Pessoa fÃ­sica" },
	{ key: "PJ", label: "Pessoa juridica" },
];

export const listaMeses = [
	{ key: "01", label: "Janeiro" },
	{ key: "02", label: "Fevereiro" },
	{ key: "03", label: "MarÃ§o" },
	{ key: "04", label: "Abril" },
	{ key: "05", label: "Maio" },
	{ key: "06", label: "Junho" },
	{ key: "07", label: "Julho" },
	{ key: "08", label: "Agosto" },
	{ key: "09", label: "Setembro" },
	{ key: "10", label: "Outubro" },
	{ key: "11", label: "Novembro" },
	{ key: "12", label: "Dezembro" },
];

export const STATUS_VIAGEM_LABELS = {
  SOLICITADA: { label: "Solicitada", classeKey: "badgeSolicitada" },
  ACEITA: { label: "Aceita", classeKey: "badgeAgendada" },
  EM_ANDAMENTO: { label: "Em andamento", classeKey: "badgeEmAndamento" },
  FINALIZADA: { label: "Finalizada", classeKey: "badgeFinalizada" },
  CANCELADA_PASSAGEIRO: { label: "Cancelada", classeKey: "badgeCancelada" },
  CANCELADA_MOTORISTA: { label: "Cancelada", classeKey: "badgeCancelada" },
  CANCELADA_SISTEMA: { label: "Cancelada", classeKey: "badgeCancelada" },
};
